import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function RsSlidableNavigationPrev({ disabled, onClick }) {
  return (
    <ButtonWithIcon sprite="ChevronLeft" disabled={disabled} iconOnly type="link" onClick={onClick}>
      Slide previous
    </ButtonWithIcon>
  );
}

RsSlidableNavigationPrev.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default RsSlidableNavigationPrev;
